export async function isPdfEncrypted(file: File | Blob): Promise<boolean> {
    /**
     * Searches for a specific phrase in the PDF that indicates that it is encrypted.
     * https://qpdf.readthedocs.io/en/stable/encryption.html#pdf-encryption-details
     */
    const needle = '/Encrypt';
    const asText = await file.text();
    return asText.includes(needle);
}
